const NUMBER_REGEXP = /(?<number>\d+)/;

// https://stackoverflow.com/a/1527820
export const randomInteger = (min: number = 0, max: number = 1): number => {
	min = ceilNumber(min);
	max = floorNumber(max);
	return floorNumber(Math.random() * (max - min + 1)) + min;
};

// Zaokruhlime o 2 desatinne miesta naviac
// aby sme nemali cisla typu 1.0000000001 ale len 1.00.
const fixNumber = (value: number, decimals: number): number => {
	const factor = 10 ** (decimals + 2);
	return Math.trunc(value * factor) / factor;
};

export const roundNumber = (value: number, decimals: number = 0): number => {
	const factor = 10 ** decimals;
	return Math.round(fixNumber(value, decimals) * factor) / factor;
};

export const floorNumber = (value: number, decimals: number = 0): number => {
	const factor = 10 ** decimals;
	return Math.floor(fixNumber(value, decimals) * factor) / factor;
};

export const ceilNumber = (value: number, decimals: number = 0): number => {
	const factor = 10 ** decimals;
	return Math.ceil(fixNumber(value, decimals) * factor) / factor;
};

export const getAmount = (amount: number | (() => number)): number => {
	return typeof amount === "function" ? amount() : amount;
};

export const getNumber = (string: string): number => {
	return +(string.match(NUMBER_REGEXP)?.groups?.number ?? 0);
};
